export default __webpack_public_path__ + "static/media/S-2Hub_c.d52f263d.jpg";